import axios from "@/plugins/axios";

let url = "/api/console/seedpay";

export default {
    getBalance(data){
        return axios.get(`${url}/balance`, data).then(result => result.data);
    },

    // 보류(결과 미확정) 출금건 목록
    getPendings(data){
        return axios.get(`${url}/pendings`, data).then(result => result.data);
    },

    // 결과조회 (6170) — 상태만 갱신한다
    postCheck(_exchange){
        return axios.post(`${url}/pendings/${_exchange}/check`).then(result => result.data);
    },

    // 캐시 복구 — 실제로 돈이 움직이는 호출이다
    postRestore(_exchange){
        return axios.post(`${url}/pendings/${_exchange}/restore`).then(result => result.data);
    },
}
